import React from 'react';
import clsx from 'clsx';
import {
  Dropdown,
} from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { supportedTransferTypes, datasetTransferTypesDiff } from '../helper';
import { datasetTransferTypes, automatedDatasetTransferTypes } from '../constants';

const listItems = (transferFeatures, transferTypes, intl) => {
  const supportedTypes = supportedTransferTypes(transferFeatures);
  const additionalTypes = {};
  transferTypes.forEach((transferType) => {
    if (!Object.keys(supportedTypes).includes(transferType)) {
      additionalTypes[transferType] = datasetTransferTypes[transferType];
    }
  });

  return Object.keys({ ...supportedTypes, ...additionalTypes }).map(
    (transferType) => ({
      key: `dataset_transfer_type_dropdown_item_${transferType}`,
      text: intl.formatMessage({
        id: `dataset.transfer.type.${datasetTransferTypes[transferType]
          .toLowerCase().replace(/_/g, '.')}`,
      }),
      value: transferType,
    }),
  );
};

const DatasetTransfersDropdown = ({
  category,
  className,
  code,
  disabled,
  name,
  transferTypes,
  datasourceTransferFeatures,
  updateDatasetSettings,
}) => {
  const intl = useIntl();
  const disableEnabledAutomatedTransfers = (value) => value.filter((transferKey) => (
    Object.keys(automatedDatasetTransferTypes).includes(transferKey)
  )).reduce((valueMap, currentValue) => (
    {
      ...valueMap,
      [datasetTransferTypes[currentValue]]: false,
    }
  ), {});

  const onTransfersChange = (value) => {
    const change = datasetTransferTypesDiff(transferTypes, value);
    let transferChanges = {
      [change.key]: change.value,
    };
    // Check for Change to manual Status and disable appropriately
    if (change.value && change.key === (datasetTransferTypes.MANUAL)) {
      // If enabling manual then we need to make sure that automatics are disabled
      transferChanges = {
        ...transferChanges,
        ...disableEnabledAutomatedTransfers(value),
      };
    }
    if (change.value && Object.values(automatedDatasetTransferTypes).includes(change.key)) {
      // If enabling automatic then we need to make sure manual is disabled
      if (value.includes('MANUAL')) {
        transferChanges[datasetTransferTypes.MANUAL] = false;
      }
    }
    updateDatasetSettings(category, code, transferChanges, name);
  };

  return (
    <Dropdown
      className={clsx('aridhia-dataset-transfers-dropdown', className)}
      options={listItems(datasourceTransferFeatures, transferTypes, intl)}
      disabled={disabled}
      placeholder={intl.formatMessage({ id: 'dataset.select.transfer.types' })}
      value={transferTypes}
      selection
      fluid
      multiple
      onChange={(e, { value }) => onTransfersChange(value)}
    />
  );
};

export default DatasetTransfersDropdown;
